package com.vizio.redwolf.m2m.client

import com.vizio.redwolf.m2m.model.M2MTokenRequestInfo
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.CONTENT_TYPE_APP_JSON_UTF8
import com.vizio.redwolf.utils.ClientConfig
import com.vizio.redwolf.utils.HttpResult
import com.vizio.redwolf.utils.M2MEnvironment
import com.vizio.redwolf.utils.applyAppConfig
import com.vizio.redwolf.utils.applyTimeout
import com.vizio.redwolf.utils.buildHttpRequest
import com.vizio.redwolf.utils.safeHttpCall
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.headers
import io.ktor.client.request.request
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpMethod
import io.ktor.http.URLProtocol
import io.ktor.http.path
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.encodeToJsonElement

class M2MHttpClient(private val environment: M2MEnvironment, private val appConfig: AppConfig, private val clientConfig: ClientConfig) :
    M2MClient {

    private val httpClient: HttpClient = clientConfig.clientProvider.httpClient
    private val apiKey = environment.apiKey
    private val path = environment.path
    private val json = Json { encodeDefaults = true }

    override suspend fun requestM2MToken(): HttpResult<HttpResponse> {
        val requestInfo = M2MTokenRequestInfo(
            serviceId = environment.serviceId,
            serviceSecret = environment.serviceSecret
        )
        val requestBody = json.encodeToJsonElement(requestInfo)
        val httpRequestBuilder = HttpRequestBuilder().apply {
            url {
                protocol = URLProtocol.HTTPS
                host = environment.host
                path("$path/token/m2m")
            }
            headers {
                append(HttpHeaders.ContentType, CONTENT_TYPE_APP_JSON_UTF8)
                append(API_KEY_HEADER, apiKey)
            }
            setBody(requestBody)
            applyAppConfig(appConfig)
            applyTimeout(clientConfig.timeout)
            method = HttpMethod.Post
        }
        return safeHttpCall(httpRequestInfo = httpRequestBuilder.buildHttpRequest()) {
            httpClient.request(httpRequestBuilder)
        }
    }

    companion object {
        private const val API_KEY_HEADER = "x-api-key"
    }
}